import { render, staticRenderFns } from "./LifeServiceManagement.vue?vue&type=template&id=682f4508&scoped=true"
import script from "./LifeServiceManagement.vue?vue&type=script&lang=js"
export * from "./LifeServiceManagement.vue?vue&type=script&lang=js"
import style0 from "./LifeServiceManagement.vue?vue&type=style&index=0&id=682f4508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682f4508",
  null
  
)

export default component.exports